import posthog from 'posthog-js';
import { getConfig } from '@/constants/config';
import { environment } from '@/utils/env.utils';

export const getIdentifiedPostHogDistinctId = () =>
  posthog.get_property('$user_state') === 'identified' ? posthog.get_distinct_id() : null;

/** Super properties attached to every PostHog event. Call again after `posthog.reset()`, which clears them. */
export const registerBasePostHogSuperProperties = () => {
  posthog.register({
    country: getConfig().country,
    web_app_version: environment.version,
  });
};
